import React, { useEffect, useState } from 'react'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import {
  CustomDropdown,
  Btn,
  CustomCheckbox,
  SectionTitle,
  CustomDataTableHeader,
} from '../../../../../components'
import useEnvioEmailState, { ENVIO_EMAIL_ACTIONS } from './EnvioEmailState'
import { connect } from 'react-redux'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../../store/actions/system.actions'
import { tableCellCentered } from '../../../../../assets/js/styles'

export default connect()(EnvioEmail)

function EnvioEmail({ ciclo, operationCenterId, dispatch }) {
  const {
    listasEmail,
    listaSelecionada,
    isLoading,
    emails,
    selecionarTodos,
    mensagem,
    error,
    onBtnEnviarClick,
    onCheckBoxRowClicked,
    onSelecionarTodos,
    onListaEmailChange,
    resetError,
    resetMessage,
  } = useEnvioEmailState(ciclo, operationCenterId)

  const [globalFilter, setGlobalFilter] = useState('')

  useEffect(() => {
    switch (isLoading) {
      case ENVIO_EMAIL_ACTIONS.LOADING_ENVIANDO_EMAIL:
        dispatch(showLoadingBox('Enviando os Emails . . .', 'Aguarde'))
        break
      case ENVIO_EMAIL_ACTIONS.LOADING_LISTA_EMAILS:
        dispatch(showLoadingBox('Obtendo as Listas de Emails . . .', 'Aguarde'))
        break
      case ENVIO_EMAIL_ACTIONS.LOADING_EMAILS:
        dispatch(showLoadingBox('Obtendo os Emails . . .', 'Aguarde'))
        break
      default:
        dispatch(hideLoadingBox())
        break
    }
  }, [isLoading])

  useEffect(() => {
    switch (mensagem) {
      case ENVIO_EMAIL_ACTIONS.EMAIL_ENVIADOS_COM_SUCESSO:
        dispatch(showMessageBox('Emails enviados com sucesso.', null))
        resetMessage()
        break
      default:
        break
    }
  }, [mensagem])

  useEffect(() => {
    error && dispatch(showMessageBox(null, error)) && resetError()
  }, [error])

  // Render
  return (
    <div className="p-grid">
      <div className="p-col-12">
        <SectionTitle title="Enviar Programação Por Email" />
      </div>
      <div className="p-col-4">
        <CustomDropdown
          label="Selecione a Lista de Email Desejada:"
          options={listasEmail}
          optionLabel="nome"
          value={listaSelecionada}
          onChange={value => onListaEmailChange(value)}
        />
      </div>
      <div className="p-col-3" style={{ paddingTop: 33 }}>
        <Btn onClick={onBtnEnviarClick}>Enviar</Btn>
      </div>
      <div className="p-col-12">
        <CustomCheckbox checked={selecionarTodos} onChange={() => onSelecionarTodos()}>
          Selecionar Todos
        </CustomCheckbox>
      </div>
      <div className="p-col-12">
        <DataTable
          value={emails}
          emptyMessage="Selecione a Lista de Email desejada"
          rows={15}
          paginator
          globalFilter={globalFilter}
          header={<CustomDataTableHeader onChange={setGlobalFilter} />}
        >
          <Column
            field="selected"
            style={tableCellCentered(50)}
            body={email => (
              <CustomCheckbox
                checked={email.selected}
                onChange={() => onCheckBoxRowClicked(email)}
              />
            )}
          />
          <Column field="name" header="Nome" />
          <Column field="email" header="Email" />
          <Column field="tps" header="TPs" />
        </DataTable>
      </div>
    </div>
  )
}
